import { createBrowserRouter, Navigate } from "react-router-dom";
import { Shell } from "./routes/Shell.js";
import { DefaultRedirect } from "./routes/DefaultRedirect.js";
import { TodayRoute } from "./routes/today.js";
import { MonthRoute } from "./routes/calendar/month.js";
import { WeekRoute } from "./routes/calendar/week.js";
import { DaysRoute } from "./routes/calendar/days.js";
import { DayRoute } from "./routes/calendar/day.js";
import { TasksListRoute } from "./routes/tasks/list.js";
import { PrioritiesRoute } from "./routes/priorities.js";
import { InboxRoute } from "./routes/inbox.js";
import { SearchRoute } from "./routes/search.js";
import { AiRoute } from "./routes/ai.js";
import { SettingsRoute, SettingsIndex } from "./routes/settings/index.js";
import { GeneralSettings } from "./routes/settings/GeneralSettings.js";
import { AppearanceSettings } from "./routes/settings/AppearanceSettings.js";
import { ThemeSettings } from "./routes/settings/theme/ThemeSettings.js";
import { TasksSettings } from "./routes/settings/TasksSettings.js";
import { NavigationSettings } from "./routes/settings/NavigationSettings.js";
import { OrganizeSettings } from "./routes/settings/OrganizeSettings.js";
import { SyncSettings } from "./routes/settings/SyncSettings.js";
import { DataSettings } from "./routes/settings/DataSettings.js";
import { TrashSettings } from "./routes/settings/TrashSettings.js";
import { AboutSettings } from "./routes/settings/AboutSettings.js";
import { DeveloperSettings } from "./routes/settings/DeveloperSettings.js";
import { OAuthCallback } from "./routes/oauth-callback.js";
import { ResetPasswordRoute } from "./routes/reset-password.js";

export const router = createBrowserRouter([
  // Top-level (outside Shell): the Google OAuth popup landing page.
  { path: "/oauth-callback", element: <OAuthCallback /> },
  // Top-level (outside Shell): the password-reset email landing page.
  { path: "/reset-password", element: <ResetPasswordRoute /> },
  {
    path: "/",
    element: <Shell />,
    children: [
      { index: true, element: <DefaultRedirect /> },
      { path: "today", element: <TodayRoute /> },
      { path: "calendar/month", element: <MonthRoute /> },
      { path: "calendar/week", element: <WeekRoute /> },
      { path: "calendar/days", element: <DaysRoute /> },
      { path: "calendar/day", element: <DayRoute /> },
      { path: "tasks", element: <TasksListRoute /> },
      { path: "priorities", element: <PrioritiesRoute /> },
      { path: "inbox", element: <InboxRoute /> },
      { path: "search", element: <SearchRoute /> },
      { path: "ai", element: <AiRoute /> },
      {
        path: "settings",
        element: <SettingsRoute />,
        children: [
          { index: true, element: <SettingsIndex /> },
          { path: "general", element: <GeneralSettings /> },
          { path: "appearance", element: <AppearanceSettings /> },
          { path: "theme", element: <ThemeSettings /> },
          { path: "defaults", element: <Navigate to="/settings/tasks" replace /> },
          { path: "tasks", element: <TasksSettings /> },
          { path: "navigation", element: <NavigationSettings /> },
          { path: "organize", element: <OrganizeSettings /> },
          { path: "sync", element: <SyncSettings /> },
          { path: "data", element: <DataSettings /> },
          { path: "trash", element: <TrashSettings /> },
          { path: "about", element: <AboutSettings /> },
          { path: "developer", element: <DeveloperSettings /> },
        ],
      },
    ],
  },
]);
